
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsDiscCouponTypeGrid extends Serenity.EntityGrid<PsDiscCouponTypeRow, any> {
        protected getColumnsKey() { return PsDiscCouponTypeColumns.columnsKey; }
        protected getDialogType() { return PsDiscCouponTypeDialog; }
        protected getIdProperty() { return PsDiscCouponTypeRow.idProperty; }
        protected getInsertPermission() { return PsDiscCouponTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeRow.localTextPrefix; }
        protected getService() { return PsDiscCouponTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}